import { contractServiceClient } from '@lib/documentServiceClient';
import { createAuditService } from '@workpay/ds-shared/services/auditService';

export const dsAuditService = createAuditService(contractServiceClient);
